import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgRendererComponent } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { LocationTimeslot } from '@heardis/api-contracts';

@Component({
  selector: 'hdis-times',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './times.component.html',
  styleUrls: ['./times.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimesCellRendererComponent implements AgRendererComponent {
  times: LocationTimeslot[] = [];

  agInit(params: ICellRendererParams<unknown, LocationTimeslot[], unknown>): void {
    this.times = params.value || [];
  }

  refresh(_params: ICellRendererParams<unknown, unknown, unknown>): boolean {
    return false;
  }

  get orderedTimes(): LocationTimeslot[] {
    // Reorder to start from Monday (day 1) and cycle through the week
    const orderedDays = [1, 2, 3, 4, 5, 6, 0]; // Mon, Tue, Wed, Thu, Fri, Sat, Sun
    return orderedDays
      .map((dayNum) => this.times.find((t) => t.day === dayNum))
      .filter(Boolean) as LocationTimeslot[];
  }

  getDayName(day: number): string {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return days[day] || '';
  }

  isCurrentDay(day: number): boolean {
    const today = new Date().getDay();
    return today === day;
  }

  formatHours(hours: { from: string; to: string }[]): string {
    if (!hours || hours.length === 0) {
      return 'Closed';
    }
    return hours.map((h) => {
      // Check for "all day" case: from "00:00" with empty "to"
      if (h.from === '00:00' && (!h.to || h.to === '')) {
        return 'all day';
      }
      return `${h.from} - ${h.to}`;
    }).join(', ');
  }
}
